(function($) {

    'use strict';

    var CatalogAjax = function(element, options) {
        this.$element = $(element);
        this.options = options;
        this.$filters = $('[data-catalog-filters]');
        this.$filterTop = $('[data-catalog-filter-top]');
        this.$products = $('[data-catalog-products]');
        this.$breadcrumb = $('[data-catalog-breadcrumb]');
        this.$banner = $('[data-catalog-banner]');
        this.$trackingCatalog = $('[data-catalog-tracking]');
        this.$footer = $('[data-catalog-footer]');
        this.$slider = $('[data-catalog-slider]');
        this.location = window.location.href;
        this.initialPop = ('state' in window.history && window.history.state !== null);
        this.initialLocation = this.location;

        this.$element.on('click', '[data-catalog=ajax] a', $.proxy(this,'onClick'));
        this.$slider.find('.slider-input').on('change', $.proxy(this, 'onSliderChange'));
        window.onpopstate = $.proxy(this, 'onPopState');
    }

    CatalogAjax.DEFAULTS = {};

    CatalogAjax.prototype.onSliderChange = function () {
      var index = $('.slider-input:checked').index('.slider-input')
        , $slide = this.$slider.find('article a').eq(index);

      $slide.trigger('click');
    };

    CatalogAjax.prototype.onClick = function(e) {
        var target = $(e.currentTarget);
        if (target.attr('href') == '/')
            return;

        if (target.data('catalog-ajax-disabled') || target.attr('disabled') === 'disabled') {
            return;
        }

        e.preventDefault();

        if (!target.hasClass('is-disabled') && target.attr('href')) {
            this.initialPop = true;
            this.eventType = e.type;
            this.load(target.attr('href'));
        }

        this.scrollTop(target);
    }

    CatalogAjax.prototype.scrollTop = function(target) {
        if (target.data('scroll-top')) {
            $(document).trigger('dft.go-to-top');
        }
    }

    CatalogAjax.prototype.onPopState = function(e) {
        if (!this.initialPop && window.location.href == this.initialLocation) return;
        this.initialPop = true;

        e.preventDefault();
        this.eventType = e.type;
        this.load(window.location.href);
    }

    CatalogAjax.prototype.load = function(url) {
        if (this.ajaxActive) return ;

        this.ajaxActive = true;
        this.loading();

        this.location = url;
        var callUrl = this.location + ((this.location.indexOf("?") > -1) ? '&' : '?') + 'ajax=true&cat-pwa=0&campwa=0';
        $.getJSON(callUrl , $.proxy(this, 'loaded')).fail($.proxy(this, 'loaded'));
    }

    CatalogAjax.prototype.loaded = function(response) {
        this.ajaxActive = false;
        if (typeof response.body == 'undefined') {
            this.$products.find('[data-catalog-loading]').remove();
            return;
        }

        if (response.body.noResults != '' || response.body.total == 0) {
            window.location.href = this.location;
            return;
        }

        this.updateLocation();
        this.renderProducts(response.body.products);
        this.renderFilters(response.body.filter);
        this.renderBreadcrumb(response.body.breadcrumb);
        this.renderFilterTop(response.body.selectionOptions);
        this.renderFooter(response.body.footer);
        this.renderTracking(response.body.tracking);

        if(this.$slider.length == 0) {
          this.renderBannerFull(response.body.cms);
        }

        $(document).trigger('dft.catalog-ajax.loaded');
    }

    CatalogAjax.prototype.updateLocation = function() {
        if (this.eventType !== 'popstate')
            window.history.pushState(null, null, this.location);
    }

    CatalogAjax.prototype.renderProducts = function(html) {
        this.$products.empty();
        this.$products.html($(html).html());
        this.$products.find('[data-lazyload]').lazyload({
            threshold : 600,
            effect : 'fadeIn',
        });
    }

    CatalogAjax.prototype.renderFilters = function(html) {
        this.$filters.html(html);
    }

    CatalogAjax.prototype.renderBreadcrumb = function(html) {
        this.$breadcrumb.html(html);
    }

    CatalogAjax.prototype.renderFilterTop = function(html) {
        var parent = this.$filterTop;
        parent.empty();
        parent.append(html);
    }

    CatalogAjax.prototype.renderBannerFull = function(cmsContent) {
        var bannerFull = '';
        if (cmsContent.length > 0 && cmsContent[0].items.banner_full) {
            bannerFull = cmsContent[0].items.banner_full;
        } else if (cmsContent.items && cmsContent.items.banner_full) {
            bannerFull = cmsContent.items.banner_full;
        }
        this.$banner.html(bannerFull);
    }

    CatalogAjax.prototype.renderTracking = function(cmsContent) {
        if(cmsContent) {
            if($('body').find(".tracking-ajax").length == 0) {
                $('body').append('<div class="tracking-ajax">'+ cmsContent.items.text +'</div>');
            } else {
                $('.tracking-ajax').empty();
                $('.tracking-ajax').append(cmsContent.items.text);
            }
        }
    }

    CatalogAjax.prototype.renderFooter = function(html) {
        this.$footer.html(html);
    }

    CatalogAjax.prototype.loading = function() {
        this.$products.append(this.getLoadingTemplate());
    }

    CatalogAjax.prototype.getLoadingTemplate = function() {
        if (typeof this.template !== 'undefined') return this.template.clone();

        var el = this.$products.find('[data-catalog-loading]');
        this.template = el.clone().addClass('is-active');
        el.remove();
        return this.template.clone();
    }

    $.fn.catalogAjax = function(option) {
        return this.each(function() {
            var $this   = $(this);
            var data    = $this.data('dft.catalog-ajax');
            var options = $.extend({}, CatalogAjax.DEFAULTS, $this.data(), typeof option == 'object' && option);

            if (!data) $this.data('dft.catalog-ajax', (data = new CatalogAjax(this, options)));
            if (typeof option == 'string') data[option]();
        });
    }

    $(document).on('dft.catalog-ajax.load', function() {
        if (window.history.pushState) {
            $('body').catalogAjax();
        }
    })

})(jQuery);
